var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 56,
    viewBox: "0 0 36 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64606 47.4687L1.29328 47.8223L1.64645 48.1755L7.73552 54.2645L8.08907 54.6181L8.44262 54.2645L34.3536 28.3536L34.7071 28L34.3536 27.6465L8.44262 1.73556L8.08907 1.382L7.73552 1.73556L1.64645 7.82463L1.29328 8.17779L1.64606 8.53135L21.0723 28L1.64606 47.4687Z",
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.48285f51daa5d82314b8405c3933a494.svg";
export { ForwardRef as ReactComponent };